module.exports = __webpack_public_path__ + "img/valdrinName.0f27766a.svg";